module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-change-iStock-1325578537.541232b9.jpg";